// RecommendationBadge.js - Icon badge that appears on generic component nodes
import React, { useState } from 'react';
import styled from 'styled-components';
import RecommendationDropdown from './RecommendationDropdown';
import useStore from '../../store/useStore';

const RecommendationBadge = ({ nodeId, nodeType, onReplace }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { showTutorial, tutorialStep, completeTutorialAction } = useStore();

  // Disable opening until tutorial step 22 (find-similar step)
  const isDisabledByTutorial = showTutorial && tutorialStep < 22;

  const handleClick = (e) => {
    e.stopPropagation();
    // Don't open if disabled by tutorial
    if (isDisabledByTutorial) return;
    setAnchorEl(e.currentTarget);
    setIsOpen(true);
    // Track for tutorial
    if (showTutorial) {
      completeTutorialAction('findSimilarClicked');
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    setAnchorEl(null);
  };

  return (
    <>
      <BadgeIcon
        id="recommendation-badge"
        className="nodrag"
        onClick={handleClick}
        title="Find similar catalog components"
        $disabled={isDisabledByTutorial}
      >
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </BadgeIcon>

      {isOpen && (
        <RecommendationDropdown
          nodeId={nodeId}
          nodeType={nodeType}
          anchorEl={anchorEl}
          onClose={handleClose}
          onReplace={onReplace}
        />
      )}
    </>
  );
};

const BadgeIcon = styled.div`
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.$disabled ? 0.3 : 0.7};
  transition: opacity 0.15s ease, transform 0.15s ease;
  color: #ff6b6b;

  &:hover {
    opacity: ${props => props.$disabled ? 0.3 : 1};
    transform: translateY(-50%) ${props => props.$disabled ? '' : 'scale(1.15)'};
  }

  svg {
    width: 100%;
    height: 100%;
  }
`;

export default RecommendationBadge;
